import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { utils, constants } from 'ethers';
import { getChainById } from './chain';
export var GNOSIS_SAFE_ABI = ['function nonce() view returns (uint256)', 'event ExecutionSuccess(bytes32 txHash, uint256 payment)'];
export var buildSafeTransaction = function buildSafeTransaction(template) {
  return {
    to: template.to,
    value: template.value || 0,
    data: template.data || '0x',
    operation: template.operation || 0,
    safeTxGas: template.safeTxGas || 0,
    baseGas: template.baseGas || 0,
    gasPrice: template.gasPrice || 0,
    gasToken: template.gasToken || constants.AddressZero,
    refundReceiver: template.refundReceiver || constants.AddressZero,
    nonce: template.nonce || 0
  };
};
var EIP712_SAFE_TX_TYPE = {
  SafeTx: [{
    type: 'address',
    name: 'to'
  }, {
    type: 'uint256',
    name: 'value'
  }, {
    type: 'bytes',
    name: 'data'
  }, {
    type: 'uint8',
    name: 'operation'
  }, {
    type: 'uint256',
    name: 'safeTxGas'
  }, {
    type: 'uint256',
    name: 'baseGas'
  }, {
    type: 'uint256',
    name: 'gasPrice'
  }, {
    type: 'address',
    name: 'gasToken'
  }, {
    type: 'address',
    name: 'refundReceiver'
  }, {
    type: 'uint256',
    name: 'nonce'
  }]
};
export var sanitizeTransactionRequest = function sanitizeTransactionRequest(transactionRequest) {
  var _a;
  return Object.assign(Object.assign({}, transactionRequest), {
    data: (_a = transactionRequest.data) !== null && _a !== void 0 ? _a : '0x'
  });
};
export var calculateSafeTransactionHash = function calculateSafeTransactionHash(safe, safeTx, chainId) {
  return utils._TypedDataEncoder.hash({
    verifyingContract: safe.address,
    chainId: chainId
  }, EIP712_SAFE_TX_TYPE, safeTx);
};
export var getLatestNonce = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(chainId, safeAddress) {
    var _a, _b, _c, response, allTransactions, latestNonce;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("https://safe-transaction.".concat((_a = getChainById(chainId)) === null || _a === void 0 ? void 0 : _a.chainName, ".gnosis.io/api/v1/safes/").concat(safeAddress, "/all-transactions?limit=1&executed=false&queued=true"));
        case 3:
          response = _context.sent;
          if (response.ok) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", null);
        case 6:
          _context.next = 8;
          return response.json();
        case 8:
          allTransactions = _context.sent;
          latestNonce = (_c = (_b = allTransactions === null || allTransactions === void 0 ? void 0 : allTransactions.results) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.nonce;
          if (latestNonce) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", null);
        case 12:
          return _context.abrupt("return", latestNonce);
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          return _context.abrupt("return", undefined);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 15]]);
  }));
  return function getLatestNonce(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var waitForSafeTransaction = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(transactionPromise, contract, chainId, safeTx) {
    var safeTxHash;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          safeTxHash = calculateSafeTransactionHash(contract, safeTx, chainId);
          return _context3.abrupt("return", new Promise(function (resolve, reject) {
            void transactionPromise.catch(function (err) {
              if ((err === null || err === void 0 ? void 0 : err.message) === 'Transaction was rejected') {
                reject(err);
              }
            });
            var onExecutionSuccess = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(txHash, _payment, event) {
                var transaction, receipt, currentNonce, _transaction, _receipt;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!(txHash === safeTxHash)) {
                        _context2.next = 11;
                        break;
                      }
                      contract.removeListener('ExecutionSuccess', onExecutionSuccess);
                      _context2.next = 4;
                      return event.getTransaction();
                    case 4:
                      transaction = _context2.sent;
                      _context2.next = 7;
                      return event.getTransactionReceipt();
                    case 7:
                      receipt = _context2.sent;
                      resolve({
                        transaction: transaction,
                        receipt: receipt,
                        rejected: false
                      });
                      _context2.next = 23;
                      break;
                    case 11:
                      _context2.next = 13;
                      return contract.nonce();
                    case 13:
                      currentNonce = _context2.sent;
                      if (!(Number(currentNonce) > Number(safeTx.nonce))) {
                        _context2.next = 23;
                        break;
                      }
                      contract.removeListener('ExecutionSuccess', onExecutionSuccess);
                      _context2.next = 18;
                      return event.getTransaction();
                    case 18:
                      _transaction = _context2.sent;
                      _context2.next = 21;
                      return event.getTransactionReceipt();
                    case 21:
                      _receipt = _context2.sent;
                      resolve({
                        transaction: _transaction,
                        receipt: _receipt,
                        rejected: true
                      });
                    case 23:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function onExecutionSuccess(_x7, _x8, _x9) {
                return _ref3.apply(this, arguments);
              };
            }();
            contract.on('ExecutionSuccess', onExecutionSuccess);
          }));
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function waitForSafeTransaction(_x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();